<template>
  <div class="full-page">

    <!-- COHORT SELECT AND EDIT -->
    <div class="cohort-container">
      <h2>Cohorts</h2>
      <!-- Drop down menu to select from cohorts based on cohorts[i].id -->

      <div class="input-row mb-3">
        <select class="form-select" style="width: 400px;" id="cohortSelect" v-model="selectedCohortId">
          <option value="null" selected>Select a cohort...</option>
          <option v-for="cohort in cohorts" :key="cohort.id" :value="cohort.id">{{cohort.id}} - {{cohort.name}}</option>
        </select> 
        <div class="input-group ms-3" style="width: 300px;">
          <button class="input-group-text" style="width: 75px;">ID</button>
          <input type="text" class="form-control" placeholder="Enter in the course code..." id="cohortID" v-model="cohortID">    
        </div>
        <div class="input-group ms-3" style="width: 300px;">
          <button class="input-group-text" style="width: 75px;">Name</button>
          <input type="text" class="form-control" placeholder="Name this cohort..." id="cohortName" v-model="cohortName">    
        </div>
      </div>
      <div class="form-check cohort-online-toggle mb-3">
        <input class="form-check-input" type="checkbox" id="cohortOnline" v-model="cohortOnline">
        <label class="form-check-label" for="cohortOnline">
          Online cohort: enable show lesson videos for matching students
        </label>
      </div>
      <div class="input-group mb-3" style="width: 75%; height: 100px;">
        <button class="input-group-text" style="width: 100px;">Emails</button>
        <textarea type="text" class="form-control" placeholder="Enter in emails of students seperated by a comma..." id="cohortEmails" v-model="cohortEmails"></textarea>    
      </div>
      <div class="cohort-actions">
        <button class="btn btn-outline-secondary" type="button" id="editCohort" @click="editCohort">Create/Edit Cohort</button>
        <button class="btn btn-outline-danger" type="button" @click="deleteCohort" :disabled="!selectedCohortId">Delete Cohort</button>
      </div>
    </div>

    <!-- GRADEBOOK FOR SELECTED COHORT -->
    <div class="gradebook-container">
      <h2>Gradebook</h2>
      <p>Missing Students: {{ missingEmails }}</p>
      <div class="gradebook-scroll">
        <table class="table table-striped table-hover gradebook-table">
          <thead>
            <tr>
              <th v-for="column in statsGradebookColumns" :key="column.key" :class="headerClass(column)">
                {{ column.label }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="student in gradebookRows" :key="student.id">
              <td
                v-for="column in statsGradebookColumns"
                :key="`${student.id}-${column.key}`"
                :class="cellClass(column)"
                @click="openModal(column, student.rawStudent)"
              >
                {{ student[column.key] }}
              </td>
            </tr>
              
          </tbody>
        </table>
        <GradeModal v-if="showModal" :student="selectedStudent" :header="selectedHeader" :grade="selectedGrade" @close="showModal = false" @update="updateGrade"/>
      </div>
    </div>

    <!-- RESET BUTTON -->
    <button class="btn btn-outline-secondary" style="margin-top: 20px;" type="button" id="resetButton" @click="resetCourse">Reset Course for Me</button>


  </div>



</template>

<script>
import GradeModal from '@/components/GradeModal.vue';
import { collection, getDocs, doc, getDoc, setDoc } from "firebase/firestore"; 
import { auth, database } from '@/main';
import { create, all } from 'mathjs'
const math = create(all);


export default {
  name: 'controlPanel',
  components: {
    GradeModal
  },
  data() {
    return {
      users: [],
      cohorts: [],
      gradebook: [],
      missingEmails: "",
      selectedCohortId: null,
      cohortID: '',
      cohortName: '',
      cohortEmails: '',
      cohortOnline: false,
      statsGradebookColumns: [
        { key: 'studentLabel', label: 'Student', sticky: true },
        { key: 'total', label: 'Total' },
        { key: 'ec', label: 'EC' },
        { key: 'l1', label: 'L1' },
        { key: 'l2', label: 'L2' },
        { key: 'l3', label: 'L3' },
        { key: 'l4', label: 'L4' },
        { key: 'l5', label: 'L5' },
        { key: 'l6', label: 'L6' },
        { key: 'l7', label: 'L7' },
        { key: 'l8', label: 'L8' },
        { key: 'l9', label: 'L9' },
        { key: 'l10', label: 'L10' },
        { key: 'l11', label: 'L11' },
        { key: 'l12', label: 'L12' },
        { key: 'l13', label: 'L13' },
        { key: 'l14', label: 'L14' },
        { key: 'e0', label: 'E0' },
        { key: 'e1', label: 'E1' },
        { key: 'e2', label: 'E2' },
        { key: 'e3', label: 'E3' },
        { key: 'e4', label: 'E4' },
        { key: 'e5', label: 'E5' },
        { key: 'e6', label: 'E6' },
        { key: 'e7', label: 'E7' },
        { key: 'e8', label: 'E8' },
        { key: 'e9', label: 'E9' },
        { key: 'e10', label: 'E10' },
        { key: 'e11', label: 'E11' },
        { key: 'e12', label: 'E12' },
        { key: 'e13', label: 'E13' },
        { key: 'e14', label: 'E14' },
        { key: 'c1', label: 'C1' },
        { key: 'c2', label: 'C2' },
        { key: 'c3', label: 'C3' },
        { key: 'c4', label: 'C4' },
        { key: 'c5', label: 'C5' },
        { key: 'c6', label: 'C6' },
        { key: 'c7', label: 'C7' },
        { key: 'c8', label: 'C8' },
        { key: 'c9', label: 'C9' },
        { key: 'c10', label: 'C10' },
        { key: 'c11', label: 'C11' },
        { key: 'c12', label: 'C12' },
        { key: 'c13', label: 'C13' },
        { key: 'c14', label: 'C14' },
      ],
      showModal: false,
      selectedStudent: '',
      selectedHeader: '',
      selectedGrade: '',
    };
  },
  async created() {
    await this.loadUsers();
    this.cohorts = await this.getCohorts();
    console.log(this.users, this.cohorts);
  },
  watch: {
    selectedCohortId(newVal) {
      this.updateCohortDetails(newVal);
    }
  },
  computed: {
    gradebookRows() {
      return this.gradebook.map(student => this.createStudentGradebook(student));
    },
  },
  methods: {
    async loadUsers() {
      const usersRef = collection(database, 'users');
      const snapshot = await getDocs(usersRef);
      this.users = [];
      snapshot.forEach(doc => {
        let user = doc.data();
        user.id = doc.id;
        this.users.push(user);
      });
    },
    async getCohorts() {
      const docRef = doc(database, "users", auth.currentUser.uid);
      const docSnap = await getDoc(docRef);
      let data = docSnap.data();
      return data.cohorts;
    },
    updateCohortDetails(cohortId) {
      const selectedCohort = this.cohorts.find(cohort => cohort.id === cohortId);
      if (selectedCohort) {
        this.cohortID = selectedCohort.id;
        this.cohortName = selectedCohort.name;
        this.cohortEmails = selectedCohort.emails.toLowerCase(); // Assuming emails is an array
        this.cohortOnline = Boolean(selectedCohort.online);
        const cohortEmailList = this.parseCohortEmails(selectedCohort.emails);
        let newGradebook = [];
        this.users.forEach(user => {
          if (cohortEmailList.includes(user.userInfo.email.toLowerCase())) {
            newGradebook.push(user);
          }
        });
        console.log(newGradebook);
        this.missingEmails = cohortEmailList.filter(email => !newGradebook.map(user => user.userInfo.email.toLowerCase()).includes(email)).join(", ");
        this.gradebook = newGradebook;
      } else {
        this.cohortID = '';
        this.cohortName = '';
        this.cohortEmails = '';
        this.cohortOnline = false;
      }
    },
    async applyOnlineCohortToStudents(cohortEmails) {
      const matchingUsers = this.users.filter((user) => {
        const studentEmail = user.userInfo?.email?.toLowerCase();
        return studentEmail && cohortEmails.includes(studentEmail);
      });

      await Promise.all(
        matchingUsers.map((user) =>
          setDoc(doc(database, "users", user.id), {
            userInfo: {
              ...(user.userInfo || {}),
              showLessonVideos: true,
            }
          }, { merge: true })
        )
      );
    },
    async editCohort() {
      // Check to make sure all fields are filled out and give ui alert if not
      if (!this.cohortID || !this.cohortName || !this.cohortEmails) {
        alert('Please fill out all fields');
        return;
      }
      // Set Create/Edit Cohort button to to a spinning icon
      document.getElementById('editCohort').innerHTML = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Updating...';
      // Add logic to create or edit cohort
      const docRef = doc(database, "users", auth.currentUser.uid);
      const docSnap = await getDoc(docRef);
      let data = docSnap.data();
      const cohortEmailList = this.parseCohortEmails(this.cohortEmails);
      // check if cohort already exists
      let cohortIndex = data.cohorts.findIndex(cohort => cohort.id === this.cohortID);
      if (cohortIndex === -1) {
        // Create new cohort
        data.cohorts.push({
          id: this.cohortID,
          name: this.cohortName,
          emails: this.cohortEmails,
          online: this.cohortOnline,
        });
      } else {
        // Edit existing cohort
        data.cohorts[cohortIndex] = {
          id: this.cohortID,
          name: this.cohortName,
          emails: this.cohortEmails,
          online: this.cohortOnline,
        };
      }
      await setDoc(docRef, data);
      if (this.cohortOnline) {
        await this.applyOnlineCohortToStudents(cohortEmailList);
        await this.loadUsers();
      }
      this.cohorts = await this.getCohorts();
      this.updateCohortDetails(this.cohortID);
      document.getElementById('editCohort').innerHTML = 'Create/Edit Cohort';
    },
    async deleteCohort() {
      if (!this.selectedCohortId) {
        return;
      }
      const confirmed = window.confirm(`Delete cohort "${this.selectedCohortId}"?`);
      if (!confirmed) {
        return;
      }

      const docRef = doc(database, "users", auth.currentUser.uid);
      const docSnap = await getDoc(docRef);
      let data = docSnap.data();
      data.cohorts = data.cohorts.filter(cohort => cohort.id !== this.selectedCohortId);
      await setDoc(docRef, data);

      this.cohorts = data.cohorts;
      this.selectedCohortId = null;
      this.gradebook = [];
      this.missingEmails = "";
      this.cohortID = '';
      this.cohortName = '';
      this.cohortEmails = '';
      this.cohortOnline = false;
    },
    parseCohortEmails(emails) {
      return emails
        .split(',')
        .map(email => email.trim().toLowerCase())
        .filter(Boolean);
    },
    roundGrade(value) {
      return Math.round((Number(value) + Number.EPSILON) * 100) / 100;
    },
    formatStudentLabel(student) {
      const email = student.userInfo.email;
      const firstName = student.userInfo.firstName?.trim();
      const lastName = student.userInfo.lastName?.trim();
      const fullName = [firstName, lastName].filter(Boolean).join(' ');
      return fullName ? `${email} - ${fullName}` : email;
    },
    createStudentGradebook(student) {
      const gradeBook = student.stats?.gradeBook ?? {};
      return {
        id: student.id,
        rawStudent: student,
        studentLabel: this.formatStudentLabel(student),
        total: this.totalGrade(student),
        ec: this.roundGrade(gradeBook.ch0?.ec ?? 0),
        l1: this.learnGrade(gradeBook.ch1),
        l2: this.learnGrade(gradeBook.ch2),
        l3: this.learnGrade(gradeBook.ch3),
        l4: this.learnGrade(gradeBook.ch4),
        l5: this.learnGrade(gradeBook.ch5),
        l6: this.learnGrade(gradeBook.ch6),
        l7: this.learnGrade(gradeBook.ch7),
        l8: this.learnGrade(gradeBook.ch8),
        l9: this.learnGrade(gradeBook.ch9),
        l10: this.learnGrade(gradeBook.ch10),
        l11: this.learnGrade(gradeBook.ch11),
        l12: this.learnGrade(gradeBook.ch12),
        l13: this.learnGrade(gradeBook.ch13),
        l14: this.learnGrade(gradeBook.ch14),
        e0: this.roundGrade(gradeBook.ch0?.lesson ?? 0),
        e1: this.roundGrade(gradeBook.ch1?.lesson ?? 0),
        e2: this.roundGrade(gradeBook.ch2?.lesson ?? 0),
        e3: this.roundGrade(gradeBook.ch3?.lesson ?? 0),
        e4: this.roundGrade(gradeBook.ch4?.lesson ?? 0),
        e5: this.roundGrade(gradeBook.ch5?.lesson ?? 0),
        e6: this.roundGrade(gradeBook.ch6?.lesson ?? 0),
        e7: this.roundGrade(gradeBook.ch7?.lesson ?? 0),
        e8: this.roundGrade(gradeBook.ch8?.lesson ?? 0),
        e9: this.roundGrade(gradeBook.ch9?.lesson ?? 0),
        e10: this.roundGrade(gradeBook.ch10?.lesson ?? 0),
        e11: this.roundGrade(gradeBook.ch11?.lesson ?? 0),
        e12: this.roundGrade(gradeBook.ch12?.lesson ?? 0),
        e13: this.roundGrade(gradeBook.ch13?.lesson ?? 0),
        e14: this.roundGrade(gradeBook.ch14?.lesson ?? 0),
        c1: this.roundGrade(gradeBook.ch1?.assignment ?? 0),
        c2: this.roundGrade(gradeBook.ch2?.assignment ?? 0),
        c3: this.roundGrade(gradeBook.ch3?.assignment ?? 0),
        c4: this.roundGrade(gradeBook.ch4?.assignment ?? 0),
        c5: this.roundGrade(gradeBook.ch5?.assignment ?? 0),
        c6: this.roundGrade(gradeBook.ch6?.assignment ?? 0),
        c7: this.roundGrade(gradeBook.ch7?.assignment ?? 0),
        c8: this.roundGrade(gradeBook.ch8?.assignment ?? 0),
        c9: this.roundGrade(gradeBook.ch9?.assignment ?? 0),
        c10: this.roundGrade(gradeBook.ch10?.assignment ?? 0),
        c11: this.roundGrade(gradeBook.ch11?.assignment ?? 0),
        c12: this.roundGrade(gradeBook.ch12?.assignment ?? 0),
        c13: this.roundGrade(gradeBook.ch13?.assignment ?? 0),
        c14: this.roundGrade(gradeBook.ch14?.assignment ?? 0),
      }
    },
    headerClass(column) {
      return {
        'sticky-column': column.sticky,
        'student-column': column.key === 'studentLabel',
      };
    },
    cellClass(column) {
      return {
        'sticky-column': column.sticky,
        'student-column': column.key === 'studentLabel',
        'clickable-grade': column.key !== 'studentLabel' && column.key !== 'total',
      };
    },
    totalGrade(user) {
      let total = 0;
      for (const chapter of Object.values(user.stats?.gradeBook ?? {})) {
        if (!chapter) continue;
        if (chapter.ec) total += Number(chapter.ec);
        if (chapter.lesson) total += Number(chapter.lesson);
        if (chapter.assignment) total += Number(chapter.assignment);
        // Keep full precision until the total is rounded below.
        for (let module = 1; module <= 10; module++) {
          if (chapter[`mod${module}`]) total += math.sum(chapter[`mod${module}`]);
        }
      }
      return this.roundGrade(total);
    },
    learnGrade(user) {
      if (!user) return 0;
      let total = 0;
      if(user.mod1) total += math.sum(user.mod1);
      if(user.mod2) total += math.sum(user.mod2);
      if(user.mod3) total += math.sum(user.mod3);
      if(user.mod4) total += math.sum(user.mod4);
      if(user.mod5) total += math.sum(user.mod5);
      if(user.mod6) total += math.sum(user.mod6);
      if(user.mod7) total += math.sum(user.mod7);
      if(user.mod8) total += math.sum(user.mod8);
      if(user.mod9) total += math.sum(user.mod9);
      if(user.mod10) total += math.sum(user.mod10);
      return this.roundGrade(total);
    },
    openModal(column, student) {
      const header = column.label;
      this.selectedStudent = student;
      this.selectedHeader = header;
      this.selectedGrade = this.createStudentGradebook(student)[column.key];
      if (column.key === 'studentLabel') return;
      if (header === 'Total') return;
      if (header === 'EC') {
        this.showModal = true;
      };
    },
    async updateGrade(payload) {
      console.log(`Updated grade for ${payload.id} in ${payload.header}: ${payload.grade}`);
      this.showModal = false;

      if(payload.header === 'EC') {
        const student = this.selectedStudent;
        const docRef = doc(database, "users", payload.id);
        await setDoc(docRef, {
          stats: {
            gradeBook: {
              ch0: {
                ec: Number(payload.grade),
              }
            }
          }
        }, {merge: true});
        // New accounts may not have opened Statistics yet.
        student.stats ??= {};
        student.stats.gradeBook ??= {};
        student.stats.gradeBook.ch0 ??= {};
        student.stats.gradeBook.ch0.ec = Number(payload.grade);
      }
    },
    async resetCourse() {
      console.log('Resetting course for me: ', auth.currentUser.uid);
      const docRef = doc(database, "users", auth.currentUser.uid);
      await setDoc(docRef, {
        stats: {
        }
      }, {merge: true});
    },
  },
};
</script>

<style scoped>
.full-page {
  margin: 24px;
  display: block;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
.cohort-container {
  display: flex;
  flex-direction: column;
  background-color: #ccc;
  padding: 12px;
  border-radius: 15px;
  margin-bottom: 24px;
}
.input-row {
  display: flex;
  flex-direction: row;
}
.cohort-actions {
  display: flex;
  gap: 12px;
}
.cohort-online-toggle {
  margin-left: 4px;
}
.gradebook-container {
  display: flex;
  flex-direction: column;
  background-color: #ccc;
  padding: 12px;
  border-radius: 15px;
}
.gradebook-scroll {
  max-width: 100%;
  max-height: 72vh;
  overflow: auto;
  border: 1px solid #b6b6b6;
  border-radius: 12px;
  background-color: #f7f7f7;
}
.gradebook-table {
  margin-bottom: 0;
  width: max-content;
  min-width: 100%;
  table-layout: fixed;
}
.gradebook-table th,
.gradebook-table td {
  min-width: 72px;
  padding: 0.65rem 0.75rem;
  white-space: nowrap;
  text-align: center;
  vertical-align: middle;
}
.gradebook-table thead th {
  position: sticky;
  top: 0;
  z-index: 3;
  background-color: #e3e3e3;
}
.sticky-column {
  position: sticky;
  left: 0;
  z-index: 2;
  background-color: #f7f7f7;
}
.gradebook-table thead .sticky-column {
  z-index: 4;
  background-color: #d7d7d7;
}
.student-column {
  min-width: 320px !important;
  max-width: 420px;
  text-align: left !important;
}
.clickable-grade {
  cursor: pointer;
}
@media (max-width: 991px) {
  .input-row {
    flex-direction: column;
  }
  .cohort-actions {
    flex-direction: column;
  }
  .gradebook-scroll {
    max-height: none;
  }
}
</style>
